module.exports = __webpack_public_path__ + "../assets/img/0c3830b9165354ee1872f1ef430116a2.svg";